<div class="search-div">
  <button mat-raised-button data-testid="lp-logistics-create-button" matTooltip="Add individual logistic" (click)="onCreate()" [disabled]="
      !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsNotComplete') ||
      (currentExperiment | statusIs : ['Complete'])
    ">
    <mat-icon>add</mat-icon>Create
  </button>
  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input matInput type="text" autocomplete="off" data-testid="lp-logistics-search-input" [(ngModel)]="searchKey" (ngModelChange)="onChange()" />
    <button *ngIf="searchKey" matSuffix mat-icon-button data-testid="lp-logistics-search-clear-button" aria-label="Clear search" (click)="onSearchClear()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!searchKey">search</mat-icon>
  </mat-form-field>
  <!-- To honor Logistic Import/Append, remove the [overrideIsImportStatus] binding -->
  <!-- Note: Must also update changedJSON messaging and performImport(...)'s TODO -->
  <app-xls-import matTooltip="Import logistics from excel spread sheet" [overrideIsImportStatus]="true"
    (jsonChanged)="changedJSON($event)" [disabled]="
      !(currentRoles | hasAnyRoles : ['WRITER'] : currentExperiment : 'IsNotComplete') ||
      (currentExperiment | statusIs : ['Complete'])
    ">
  </app-xls-import>
  <mat-icon *ngIf="logisticsAuditCountMap && logistic && logisticsAuditCountMap[logistic.logisticId] > 0"
    class="audit-count-icon" matTooltip="{{
      logisticsAuditCountMap && logistic && logisticsAuditCountMap[logistic.logisticId]
    }} change log records" matBadgeColor="warn" (click)="showAuditDialog(logistic)">
    receipt_long
  </mat-icon>

  <div class="progress-bar-container" *ngIf="apiService.isLoading$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="mat-elevation-z1">
  <mat-table [dataSource]="listData" data-testid="lp-logistics-table" matSort>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.name }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="value">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Value</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.value }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button mat-icon-button matTooltip="Edit logistic" [attr.data-testid]="'lp-logistics-edit-button-' + row.logisticId" (click)="onEdit(row)" [disabled]="
            !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsNotComplete') ||
            (currentExperiment | statusIs : ['Complete'])
          ">
          <mat-icon> edit </mat-icon>
        </button>
        <button mat-icon-button matTooltip="Delete logisitic" [attr.data-testid]="'lp-logistics-delete-button-' + row.logisticId" (click)="onDelete(row)" [disabled]="
            !(currentRoles | hasAnyRoles : ['WRITER'] : currentExperiment : 'IsNotComplete') ||
            (currentExperiment | statusIs : ['Complete'])
          ">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="6"> Loading data... </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="6"> No data. </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: listData != null }"></mat-footer-row>
    <mat-footer-row *matFooterRowDef="['noData']"
      [ngClass]="{ hide: !(listData != null && listData.data.length == 0) }"></mat-footer-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>